export const en = {
  common: {
    loading: "Loading...",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    create: "Create",
    search: "Search",
    filter: "Filter",
    refresh: "Refresh",
    submit: "Submit",
    confirm: "Confirm",
    back: "Back",
    next: "Next",
    close: "Close",
    yes: "Yes",
    no: "No",
    or: "or",
    and: "and",
    all: "All",
    none: "None",
    select: "Select",
    view: "View",
    download: "Download",
    share: "Share",
    copy: "Copy",
    copied: "Copied!",
    success: "Success",
    error: "Error",
    warning: "Warning",
    info: "Info",
    online: "Online",
    offline: "Offline",
    busy: "Busy",
    from: "From",
    hour: "hour",
    job: "job",
    more: "more",
    providers: "Providers",
    step: "Step",
    upload: "Upload",
    uploadImage: "Upload Image",
    chooseFile: "Choose file",
    dragDrop: "or drag and drop",
    maxFileSize: "Max file size",
  },
  nav: {
    home: "Home",
    browse: "Browse Services",
    howItWorks: "How It Works",
    forProfessionals: "For Professionals",
    login: "Login",
    signup: "Sign Up",
    logout: "Sign Out",
    profile: "Profile",
    wallet: "Wallet",
    messages: "Messages",
    notifications: "Notifications",
    bookmarks: "Saved Providers",
    admin: "Admin Dashboard",
    chat: "Chat",
  },
  auth: {
    login: "Login",
    signup: "Sign Up",
    email: "Email",
    password: "Password",
    confirmPassword: "Confirm Password",
    fullName: "Full Name",
    forgotPassword: "Forgot Password?",
    resetPassword: "Reset Password",
    noAccount: "Don't have an account?",
    hasAccount: "Already have an account?",
    loginSuccess: "Logged in successfully",
    signupSuccess: "Account created successfully",
    logoutSuccess: "Logged out successfully",
    loginRequired: "Please log in to continue",
  },
  wallet: {
    title: "Wallet",
    balance: "Balance",
    topUp: "Top Up",
    withdraw: "Withdraw",
    transfer: "Transfer",
    history: "Transaction History",
    sendMoney: "Send Money",
    receiveMoney: "Receive Money",
    airtime: "Buy Airtime",
    giftCard: "Gift Cards",
    amount: "Amount",
    recipient: "Recipient",
    description: "Description",
    transactionSuccess: "Transaction successful",
    insufficientFunds: "Insufficient funds",
  },
  invoice: {
    title: "Invoices",
    createInvoice: "Create Invoice",
    invoiceNumber: "Invoice Number",
    customer: "Customer",
    customerName: "Customer Name",
    customerEmail: "Customer Email",
    customerPhone: "Customer Phone",
    items: "Items",
    addItem: "Add Item",
    itemDescription: "Description",
    quantity: "Quantity",
    unitPrice: "Unit Price",
    subtotal: "Subtotal",
    tax: "Tax",
    discount: "Discount",
    total: "Total",
    dueDate: "Due Date",
    status: "Status",
    draft: "Draft",
    sent: "Sent",
    viewed: "Viewed",
    paid: "Paid",
    overdue: "Overdue",
    cancelled: "Cancelled",
    sendInvoice: "Send Invoice",
    generatePaymentLink: "Generate Payment Link",
    markAsPaid: "Mark as Paid",
    notes: "Notes",
    terms: "Terms & Conditions",
    attachment: "Attachment",
    uploadAttachment: "Upload Attachment",
  },
  paymentLink: {
    title: "Payment Links",
    createLink: "Create Payment Link",
    linkTitle: "Title",
    amount: "Amount",
    currency: "Currency",
    description: "Description",
    attachment: "Attachment",
    addAttachment: "Add Attachment",
    removeAttachment: "Remove Attachment",
    expiresAt: "Expires At",
    shareVia: "Share Via",
    whatsapp: "WhatsApp",
    email: "Email",
    copyLink: "Copy Link",
    qrCode: "QR Code",
    active: "Active",
    expired: "Expired",
    paid: "Paid",
  },
  currency: {
    title: "Currency",
    convert: "Convert",
    from: "From",
    to: "To",
    rate: "Rate",
    lastUpdated: "Last Updated",
    converter: "Currency Converter",
  },
  language: {
    title: "Language",
    select: "Select Language",
    english: "English",
    yoruba: "Yorùbá",
    hausa: "Hausa",
    igbo: "Igbo",
  },
  services: {
    title: "Services",
    browse: "Browse Services",
    search: "Search services...",
    category: "Category",
    location: "Location",
    allLocations: "All Locations",
    price: "Price",
    rating: "Rating",
    reviews: "Reviews",
    book: "Book Now",
    contact: "Contact Provider",
    viewProfile: "View Profile",
    noProvidersFound: "No providers found",
    noProvidersInCategory: "No service providers available in this category yet.",
    noResultsFor: "No results for",
    tryDifferentSearch: "Try a different search.",
    browseAllCategories: "Browse All Categories",
    backToCategories: "Back to Categories",
    searchResults: "Search Results",
    allCategories: "All Categories",
  },
  provider: {
    title: "Provider",
    services: "My Services",
    addService: "Add Service",
    editService: "Edit Service",
    availability: "Availability",
    location: "Service Location",
    verification: "Verification",
    subscription: "Subscription",
    earnings: "Earnings",
    bookAppointment: "Book Appointment",
    message: "Message",
    shareProfile: "Share Profile",
    verified: "Verified",
    idVerified: "ID Verified",
    phoneVerified: "Phone Verified",
    tradeCertified: "Trade Certified",
    aboutMe: "About Me",
    skillsAndServices: "Skills & Services",
    pricing: "Pricing",
    perHour: "per hour",
    statistics: "Statistics",
    jobsCompleted: "Jobs Completed",
    memberSince: "Member Since",
    responseRate: "Response Rate",
    pricingNote: "Final pricing depends on job scope. Contact for quotes.",
    selectDate: "Select Date",
    preferredTime: "Preferred Time",
    notesOptional: "Notes (optional)",
    notesPlaceholder: "Describe what you need help with...",
    confirmBooking: "Confirm Booking",
    appointmentSent: "Appointment request sent!",
    profileCopied: "Profile link copied to clipboard!",
    noGallery: "No gallery images yet",
    about: "About",
    gallery: "Gallery",
    reviews: "Reviews",
  },
  notifications: {
    title: "Notifications",
    markAllRead: "Mark all as read",
    noNotifications: "No notifications yet",
    broadcast: "Announcement",
  },
  errors: {
    somethingWrong: "Something went wrong",
    tryAgain: "Please try again",
    notFound: "Not found",
    unauthorized: "Unauthorized",
    forbidden: "Access denied",
    loginToMessage: "Please log in to message providers",
    loginToBook: "Please log in to book an appointment",
    selectDate: "Please select a date",
  },
  admin: {
    title: "Admin Dashboard",
    platformManagement: "Platform Management",
    pendingVerifications: "Pending Verifications",
    pendingApprovals: "Pending Approvals",
    totalUsers: "Total Users",
    serviceProviders: "Service Providers",
    verifications: "Verifications",
    transactions: "Transactions",
    users: "Users",
    broadcasts: "Broadcasts",
    logs: "Logs",
    geolocation: "Geolocation",
    maintenance: "Maintenance",
    currency: "Currency",
    apiKeys: "API Keys",
    referrals: "Referrals",
    approve: "Approve",
    reject: "Reject",
    deleteUser: "Delete User",
    promoteToProvider: "Promote to Provider",
    demoteToCustomer: "Demote to Customer",
    accessDenied: "Access Denied",
    noAdminPrivileges: "You do not have administrator privileges to access this page.",
    returnHome: "Return to Homepage",
    exchangeRateAPI: "Exchange Rate API",
    flutterwave: "Flutterwave",
    paystack: "Paystack",
    opay: "OPay",
  },
  footer: {
    company: "Company",
    about: "About Us",
    careers: "Careers",
    press: "Press",
    resources: "Resources",
    helpCenter: "Help Center",
    safety: "Safety Center",
    trust: "Trust & Safety",
    legal: "Legal",
    terms: "Terms of Service",
    privacy: "Privacy Policy",
    cookies: "Cookies",
    refund: "Refund Policy",
    connect: "Connect",
    newsletter: "Newsletter",
    enterEmail: "Enter your email",
    subscribe: "Subscribe",
    subscribeSuccess: "Thanks for subscribing!",
    copyright: "All rights reserved.",
    services: "Services",
    support: "Support",
    stayUpdated: "Stay Updated",
    mobileAccess: "Mobile Access",
    scanToOpen: "Scan to open on your phone",
    builtWithLove: "Built with ❤️ for Africa",
    constructionRepairs: "Construction & Repairs",
    automotiveServices: "Automotive Services",
    ictDigitalSkills: "ICT & Digital Skills",
    creativeMedia: "Creative & Media",
    domesticServices: "Domestic Services",
    viewAllCategories: "View All Categories",
    howItWorks: "How It Works",
    forProfessionals: "For Professionals",
    pricing: "Pricing",
    contactUs: "Contact Us",
    safetyGuidelines: "Safety Guidelines",
    trustVerification: "Trust & Verification",
    termsConditions: "Terms & Conditions",
    privacyPolicy: "Privacy Policy",
    cookiePolicy: "Cookie Policy",
    refundPolicy: "Refund Policy",
    description: "Africa's leading platform connecting skilled professionals with homeowners and businesses. Find trusted tradespeople, book services, and get the job done right.",
  },
  home: {
    heroTitle: "Find Trusted Local Service Providers",
    heroSubtitle: "Connect with verified professionals for all your service needs",
    searchPlaceholder: "What service do you need?",
    locationPlaceholder: "Your location",
    searchButton: "Search",
    popularServices: "Popular Services",
    featuredProviders: "Featured Providers",
    howItWorks: "How It Works",
    step1Title: "Search",
    step1Desc: "Find the service you need",
    step2Title: "Compare",
    step2Desc: "Review providers and prices",
    step3Title: "Book",
    step3Desc: "Schedule your appointment",
    step4Title: "Pay",
    step4Desc: "Secure payment after service",
    badgeText: "Africa's #1 Skills Marketplace",
    heroHeadline: "Find Trusted Skilled Professionals Near You",
    heroDescription: "Connect with verified handymen, artisans, technicians, and experts across Africa. Book appointments, chat in real-time, and get the job done right.",
    verifiedPros: "Verified Pros",
    averageRating: "Average Rating",
    allStates: "14 African Countries",
    browseCategories: "Browse Categories",
    findRightSkill: "Find the Right Skill for Every Job",
    categoriesDescription: "From construction to creative services, discover thousands of verified professionals ready to help with your needs.",
    topRated: "Top Rated",
    meetTrustedPros: "Meet Our Trusted Professionals",
    trustedProsDescription: "Verified experts with proven track records, ready to deliver excellent service right to your doorstep.",
    searchAllProfessionals: "Search all professionals",
    howItWorksBadge: "How It Works",
    gettingHelpSimple: "Getting Help is Simple & Easy",
    howItWorksDescription: "From search to completion, we make connecting with skilled professionals seamless and stress-free.",
    step01: "Search & Browse",
    step01Desc: "Find skilled professionals by category, location, or service type. Filter by ratings, price, and availability.",
    step02: "Review Profiles",
    step02Desc: "Check verified profiles, reviews, certifications, and past work. Compare quotes and choose the best fit.",
    step03: "Chat & Book",
    step03Desc: "Message providers directly, discuss requirements, and book appointments. Schedule virtual or in-person visits.",
    step04: "Get It Done",
    step04Desc: "Receive quality service, track progress, and leave a review. Build long-term relationships with trusted pros.",
    popularLocations: "Popular Locations",
    findProsNearYou: "Find Professionals Near You",
    popularLocationsDesc: "Browse skilled tradespeople in Nigeria's most active service areas.",
    viewAllLocations: "View all locations",
    features: "Features",
    everythingYouNeed: "Everything You Need in One Platform",
    featuresDescription: "From finding professionals to managing jobs, we've built the tools you need for a seamless experience.",
    realTimeChat: "Real-Time Chat",
    realTimeChatDesc: "Message professionals directly, share images and documents, and get instant responses with read receipts.",
    smartScheduling: "Smart Scheduling",
    smartSchedulingDesc: "Book appointments with automatic calendar sync. Get reminders and never miss a service appointment.",
    virtualMeetings: "Virtual Meetings",
    virtualMeetingsDesc: "Connect via Google Meet, Zoom, or Webex for consultations and virtual inspections when needed.",
    verifiedProfessionals: "Verified Professionals",
    verifiedProfessionalsDesc: "Every provider goes through ID verification, skill assessment, and background checks for your safety.",
    ratingsReviews: "Ratings & Reviews",
    ratingsReviewsDesc: "Make informed decisions with genuine reviews from real customers who've used the services.",
    mobileFirstDesign: "Mobile-First Design",
    mobileFirstDesignDesc: "Access everything from your phone. Search, chat, book, and manage services on the go.",
    areYouProfessional: "Are You a Skilled Professional?",
    ctaDescription: "Join thousands of tradespeople already growing their business on TaskRatel. Get discovered by customers in your area and take your skills to the next level.",
    ctaBenefit1: "Create your professional profile",
    ctaBenefit2: "Reach thousands of customers",
    ctaBenefit3: "Manage bookings & appointments",
    ctaBenefit4: "Get paid for your skills",
    joinAsProfessional: "Join as a Professional",
    learnMore: "Learn More",
    learnHowItWorks: "See How TaskRatel Works",
  },
  stats: {
    verifiedProfessionals: "Verified Professionals",
    averageRating: "Average Rating",
    averageResponse: "Average Response",
    verifiedProfiles: "Verified Profiles",
  },
  bottomNav: {
    home: "Home",
    search: "Search",
    chat: "Chat",
    wallet: "Wallet",
    profile: "Profile",
  },
  pages: {
    howItWorks: {
      title: "How It Works",
      subtitle: "Simple, Fast, Reliable",
      description: "Whether you're looking for a professional or offering your skills, getting started is easy. Here's how TaskRatel works.",
      forCustomers: "For Customers",
      forCustomersDesc: "Find and hire skilled professionals in just a few steps",
      forProviders: "For Professionals",
      forProvidersDesc: "Join thousands of skilled professionals growing their business",
      customerStep1: "Search for Services",
      customerStep1Desc: "Browse categories or search for the specific skill you need. Filter by location, ratings, and availability.",
      customerStep2: "Review Profiles",
      customerStep2Desc: "Check provider profiles, read reviews, view work samples, and compare pricing.",
      customerStep3: "Connect & Discuss",
      customerStep3Desc: "Chat with professionals, discuss your needs, share photos, and get quotes.",
      customerStep4: "Book Appointment",
      customerStep4Desc: "Schedule a convenient time using our smart booking system with calendar integration.",
      customerStep5: "Get the Job Done",
      customerStep5Desc: "Meet your professional, get quality work done, and leave a review to help others.",
      providerStep1: "Create Your Profile",
      providerStep1Desc: "Sign up and build a compelling profile showcasing your skills, experience, and work samples.",
      providerStep2: "Get Verified",
      providerStep2Desc: "Complete our verification process for ID, phone, and trade certifications to earn badges.",
      providerStep3: "Receive Inquiries",
      providerStep3Desc: "Get notified when customers in your area need your services. Chat and discuss projects.",
      providerStep4: "Book & Deliver",
      providerStep4Desc: "Accept appointments, manage your calendar, and deliver quality work.",
      providerStep5: "Grow Your Business",
      providerStep5Desc: "Collect reviews, build your reputation, and watch your customer base grow.",
    },
    faq: {
      title: "Frequently Asked Questions",
      generalTitle: "General Questions",
      q1: "What is TaskRatel?",
      a1: "TaskRatel is Nigeria's leading platform connecting customers with skilled professionals and tradespeople. Whether you need a plumber, electrician, cleaner, or any other service provider, we make it easy to find, compare, and book trusted professionals in your area.",
      q2: "How does TaskRatel work?",
      a2: "Simply search for the service you need, browse verified provider profiles, compare ratings and prices, then message or book directly. Our platform handles scheduling, payments, and reviews to ensure a smooth experience.",
      q3: "Is TaskRatel free to use?",
      a3: "Yes! It's completely free for customers to search, browse, and contact service providers. Providers pay a small subscription fee to list their services and receive bookings.",
      q4: "How are providers verified?",
      a4: "We verify providers through a multi-step process including ID verification, phone verification, and for certain trades, professional certification checks. Look for verification badges on profiles.",
      customersTitle: "For Customers",
      q5: "How do I book a service?",
      a5: "Search for the service you need, select a provider from the results, view their profile, and either message them to discuss your needs or use the 'Book Appointment' button to schedule directly.",
      q6: "How do I pay for services?",
      a6: "Payment methods include our in-app wallet, payment links, and direct payment to providers. Always use our secure payment options when possible for buyer protection.",
      q7: "What if I'm not satisfied with the service?",
      a7: "Contact the provider directly first to resolve any issues. If needed, our support team can help mediate. Check our refund policy for eligible cases.",
      providersTitle: "For Professionals",
      q8: "How do I become a provider?",
      a8: "Sign up, complete your profile with skills and experience, upload work samples, and complete verification. Once approved, you'll appear in search results and can receive bookings.",
      q9: "What are the subscription fees?",
      a9: "We offer flexible plans starting from ₦1,500/month. Each plan includes different features like priority listing, more service slots, and marketing tools. Visit our Pricing page for details.",
      q10: "How do I receive payments?",
      a10: "Payments are deposited to your TaskRatel wallet after job completion. You can withdraw to your bank account anytime with no fees.",
    },
  },
};
